import { render, staticRenderFns } from "./ApproveLevel2.vue?vue&type=template&id=e749d9fa&scoped=true"
import script from "./ApproveLevel2.vue?vue&type=script&lang=js"
export * from "./ApproveLevel2.vue?vue&type=script&lang=js"
import style0 from "./ApproveLevel2.vue?vue&type=style&index=0&id=e749d9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e749d9fa",
  null
  
)

export default component.exports